// @flow
import React, { PureComponent, Fragment } from 'react';
import Highlighter from 'react-highlight-words';
//import DropdownRadioInput from "components/fragments/input/DropdownRadioInput";
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  annuaire: Object,
  type?: string
};

type ComponentState = {
  search: string,
  annuaireSelected: string,
  department: string,
  isOpen: boolean,
  indexOpen: number,
  annuaireSelectorDisabled: boolean
};

class Annuaire extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    search: '',
    department: '',
    annuaireSelected: '',
    annuaireSelectorDisabled: false,
    isOpen: false,
    indexOpen: 0
  };

  componentDidMount = () => {};

  renderRow = (personnes: Array<{}>): any => {
    const searchWords = this.state.search.split(' ');
    if (personnes && personnes.length > 0) {
      return personnes.map((member: Object, index): any => {
        return (
          <li key={index} className="member member--row">
            <div>
              <p className="member__title ft-h4">
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={member.Personne.nom + ' ' + member.Personne.prenom}
                />
              </p>
              {member.fonction && (
                <p className="member__role ft-h6 ft-up">
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.fonction} />
                  <br />
                </p>
              )}
            </div>
            <p className="member__info">
              {member.emailPublic && (
                <a href={`mailto:${member.emailPublic}`} target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-mail is-inline"></i>
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.emailPublic} />
                </a>
              )}
              {member.telPublic && (
                <a href={`tel:${member.telPublic}`} target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-phone is-inline"></i>
                  <span>
                    <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.telPublic} />
                  </span>
                </a>
              )}
            </p>
          </li>
        );
      });
    }
    return '';
  };

  renderRowArbitres = (arbitres: Array<{}>): any => {
    const searchWords = this.state.search.split(' ');
    if (arbitres && arbitres.length > 0) {
      return arbitres.map((member: Object, index): any => {
        return (
          <li key={index} className="member member--row">
            <div>
              <p className="member__title ft-h4">
                <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.nom + ' ' + member.prenom} />
              </p>
              {member.categorieArbitrage && (
                <p className="member__role ft-h6 ft-up">
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.categorieArbitrage} />
                  <br />
                </p>
              )}
            </div>
            {member.Qualites && member.Qualites.length > 0 && (
              <p className="member__info">
                <i className="icon icon-place is-inline"></i>
                <span>
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.structure} />
                </span>
              </p>
            )}
          </li>
        );
      });
    }
    return '';
  };

  renderRowStructures = (structures: Array<{}>): any => {
    const searchWords = this.state.search.split(' ');
    if (structures && structures.length > 0) {
      return structures.map((member: Object, index): any => {
        return (
          <li key={index} className="member member--row">
            <div>
              <p className="member__title ft-h4">
                {member.siteInternet && (
                  <a href={member.siteInternet} target="_blank" rel="noopener noreferrer">
                    <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.nom} />
                  </a>
                )}
                {!member.siteInternet && <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.nom} />}
              </p>
              {member.StructureType && member.StructureType.nom && member.StructureType.nom !== 'Club' && (
                <p className="member__role ft-h6 ft-up">
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.StructureType.nom} />
                  <br />
                </p>
              )}
              {member.code && (
                <p className="member__role ft-h6 ft-up">
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.code} />
                  <br />
                </p>
              )}
              {member.Correspondant && member.Correspondant.nom && member.StructureType.nom && member.StructureType.nom !== 'Club' && (
                <p className="member__role ft-h6 ft-up">
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.Correspondant.nom} />
                  <br />
                </p>
              )}
            </div>
            <p className="member__info">
              {member.Correspondant && member.Correspondant.Adresse.email && (
                <a href={`mailto:${member.Correspondant.Adresse.email}`} target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-mail is-inline"></i>
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.Correspondant.Adresse.email} />
                </a>
              )}
              {!(member.Correspondant && member.Correspondant.Adresse.email) && member.Adresse && member.Adresse.email && (
                <a href={`mailto:${member.Adresse.email}`} target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-mail is-inline"></i>
                  <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.Adresse.email} />
                </a>
              )}
              {member.telephoneProfessionnel && (
                <a href={`tel:${member.telephoneProfessionnel}`} target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-phone is-inline"></i>
                  <span>
                    <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.telephoneProfessionnel} />
                  </span>
                </a>
              )}
              {member.StructureType && member.StructureType.nom !== 'Club' && member.Adresse && member.Adresse.voie && (
                <a
                  href={`https://www.google.com/maps/dir/?api=1&destination=${member.Adresse.voie.trim()}+${member.Adresse.codePostal.trim()}+${member.Adresse.localite
                    .replace('CEDEX', '')
                    .trim()}+${member.Adresse.paysNom.trim()}`}
                  title="Voir l'adresse sur Google Map (nouvel onglet)"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="icon icon-place is-inline"></i>
                  <span>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        member.Adresse.complement
                          ? member.Adresse.complement.trim() + ', ' + member.Adresse.voie.trim()
                          : member.Adresse.voie.trim()
                      }
                    />
                    <br />
                    {member.Adresse.codePostal && (
                      <Highlighter searchWords={searchWords} autoEscape={true} textToHighlight={member.Adresse.codePostal.trim()} />
                    )}
                    <span> </span>
                    {member.Adresse.localite && (
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={member.Adresse.localite.replace('CEDEX', '').trim()}
                      />
                    )}
                  </span>
                </a>
              )}
              {member.StructureType && member.StructureType.nom === 'Comite Departemental' && member.siteInternet && (
                <a href={member.siteInternet} title="En savoir plus" target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-info is-inline"></i> En savoir plus
                </a>
              )}
              {member.StructureType && member.StructureType.nom === 'Club' && (
                <a href={`/clubs/${member.identifiant}`} title="En savoir plus" target="_blank" rel="noopener noreferrer">
                  <i className="icon icon-place is-inline"></i> En savoir plus
                </a>
              )}
            </p>
          </li>
        );
      });
    }
    return '';
  };

  renderGroup = () => {
    const { annuaire, type } = this.props;
    let annuairesGroups;
    if (annuaire && annuaire.length > 0 && (type === 'clubs' || type === 'comites' || type === 'arbitres')) {
      annuairesGroups = annuaire.reduce((acc, obj) => {
        const cle = obj.nom.replace(/"/g, '')[0];
        const tmp = acc.filter(tab => tab.name === cle);
        if (tmp.length > 0) {
          tmp[0].child.push(obj);
          return acc;
        } else {
          return [
            ...acc,
            {
              name: cle,
              child: [obj]
            }
          ];
        }
      }, []);
      annuairesGroups.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    } else if (annuaire && annuaire.Personnes && annuaire.Personnes.length > 0) {
      annuairesGroups = annuaire.Personnes.reduce((acc, obj) => {
        const cle = obj.Personne.nom[0];
        const tmp = acc.filter(tab => tab.name === cle);
        if (tmp.length > 0) {
          tmp[0].child.push(obj);
          return acc;
        } else {
          return [
            ...acc,
            {
              name: cle,
              child: [obj]
            }
          ];
        }
      }, []);
    }
    let membersGroupsFiltered = annuairesGroups;

    if (!membersGroupsFiltered) {
      return null;
    }

    if (!type && this.state.search !== '') {
      const { search } = this.state;
      membersGroupsFiltered = membersGroupsFiltered.map(annuaire => {
        return {
          name: annuaire.name,
          child: annuaire.child.filter(
            member =>
              (member.Personne.nom &&
                member.Personne.prenom &&
                `${member.Personne.nom + ' ' + member.Personne.prenom}`.toLowerCase().includes(search.toLowerCase())) ||
              (member.fonction && member.fonction.toLowerCase().includes(search.toLowerCase())) ||
              (member.emailPublic && member.emailPublic.toLowerCase().includes(search.toLowerCase())) ||
              (member.telPublic && member.telPublic.toLowerCase().includes(search.toLowerCase()))
          )
        };
      });
    }

    if ((type === 'clubs' || type === 'comites') && this.state.search !== '') {
      const { search } = this.state;
      membersGroupsFiltered = membersGroupsFiltered.map(annuaire => {
        return {
          name: annuaire.name,
          child: annuaire.child.filter(
            member =>
              (member.nom && member.nom.toLowerCase().includes(search.toLowerCase())) ||
              (member.code && member.code.toLowerCase().includes(search.toLowerCase())) ||
              (member.Correspondant && member.Correspondant.nom && member.Correspondant.nom.toLowerCase().includes(search.toLowerCase())) ||
              (member.Correspondant &&
                member.Correspondant.Adresse.email &&
                member.Correspondant.Adresse.email.toLowerCase().includes(search.toLowerCase())) ||
              (member.telephoneProfessionnel && member.telephoneProfessionnel.toLowerCase().includes(search.toLowerCase())) ||
              (member.Adresse && member.Adresse.localite && member.Adresse.localite.toLowerCase().includes(search.toLowerCase())) ||
              (member.Adresse && member.Adresse.voie && member.Adresse.voie.toLowerCase().includes(search.toLowerCase())) ||
              (member.Adresse && member.Adresse.codePostal && member.Adresse.codePostal.toLowerCase().includes(search.toLowerCase())) ||
              (member.Adresse && member.Adresse.complement && member.Adresse.complement.toLowerCase().includes(search.toLowerCase())) ||
              (member.StructureType.nom &&
                member.StructureType.nom !== 'Club' &&
                member.Correspondant &&
                member.Correspondant.nom &&
                member.Correspondant.nom.toLowerCase().includes(search.toLowerCase()))
          )
        };
      });
    }

    if (type === 'arbitres' && this.state.search !== '') {
      const { search } = this.state;
      membersGroupsFiltered = membersGroupsFiltered.map(annuaire => {
        return {
          name: annuaire.name,
          child: annuaire.child.filter(
            member =>
              (member.nom && `${member.nom + ' ' + member.prenom}`.toLowerCase().includes(search.toLowerCase())) ||
              (member.structure && member.structure.toLowerCase().includes(search.toLowerCase())) ||
              (member.categorieArbitrage && member.categorieArbitrage.toLowerCase().includes(search.toLowerCase()))
          )
        };
      });
    }

    membersGroupsFiltered = membersGroupsFiltered.filter(annuaire => {
      return annuaire.child.length > 0;
    });
    if (membersGroupsFiltered.length > 0) {
      return (
        <>
          <div className="row directory">
            {membersGroupsFiltered.map((members, index) => {
              if (members.child.length > 0) {
                return (
                  <Fragment key={index}>
                    <div className="col col-lg-1on9">
                      <span className="directory__ref ft-700">{members.name}</span>
                    </div>
                    <div className="col col-lg-7on9">
                      <div className="directory__items">
                        <ul className="directory__members box box--smoke">
                          {!type && this.renderRow(members.child)}
                          {type && (type === 'clubs' || type === 'comites') && this.renderRowStructures(members.child)}
                          {type && type === 'arbitres' && this.renderRowArbitres(members.child)}
                        </ul>
                      </div>
                    </div>
                  </Fragment>
                );
              }
              return '';
            })}
          </div>
        </>
      );
    } else if (this.state.search !== '') {
      return (
        <div className="placeholder">
          <p className="ft-h5">
            <i className="icon icon-articles-empty"></i>
            <br />
            {type === 'clubs' ? 'Aucun club pour cette recherche' : 'Aucune personne pour cette recherche'}
          </p>
        </div>
      );
    }
    return null;
  };

  handleClickDepartment = (index: number) => {
    return () => {
      if (this.state.isOpen && index !== this.state.indexOpen) {
        this.setState({
          indexOpen: index
        });
      } else {
        this.setState(prevState => ({
          isOpen: !prevState.isOpen,
          indexOpen: index
        }));
      }
    };
  };

  handleDropdownAnnuaireChange = (value: string) => {
    this.setState({
      annuaireSelected: value
    });
  };

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      this.setState({
        search: e.target.value,
        annuaireSelectorDisabled: e.target.value !== ''
      });
    }
  };

  render() {
    const { annuaire, type } = this.props;

    const { isOpen } = this.state;

    let annuairesGroups;
    if (annuaire && annuaire.length > 0 && (type === 'clubs' || type === 'comites' || type === 'arbitres')) {
      annuairesGroups = annuaire.reduce((acc, obj) => {
        const cle = obj.nom.replace(/"/g, '')[0];
        const tmp = acc.filter(tab => tab.name === cle);
        if (tmp.length > 0) {
          tmp[0].child.push(obj);
          return acc;
        } else {
          return [
            ...acc,
            {
              name: cle,
              child: [obj]
            }
          ];
        }
      }, []);
      annuairesGroups.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    } else if (annuaire && annuaire.Personnes && annuaire.Personnes.length > 0) {
      const PersonnesOk = annuaire.Personnes.filter(Personne => Personne.Personne && Personne.Personne.nom);
      annuaire.Personnes = PersonnesOk;
      annuairesGroups = annuaire.Personnes.reduce((acc, obj) => {
        const cle = obj.Personne.nom[0];
        const tmp = acc.filter(tab => tab.name === cle);
        if (tmp.length > 0) {
          tmp[0].child.push(obj);
          return acc;
        } else {
          return [
            ...acc,
            {
              name: cle,
              child: [obj]
            }
          ];
        }
      }, []);
    }

    const rowClassName = dynamicClassName('row directory');
    isOpen && rowClassName.add('has-accordion-open');
    let placeholder = 'Saisir le nom ou une fonction';
    if (type === 'clubs') {
      placeholder = 'Saisir le nom ou une ville';
    } else if (type === 'comites') {
      placeholder = 'Saisir le nom ou un département';
    }
    if (annuairesGroups) {
      return (
        <>
          <div className="page__head mb-3 mt-4">
            {type && type === 'clubs' && <h3>Les clubs</h3>}
            {type && type === 'comites' && <h3>Les comités départementaux</h3>}
            {type && type === 'arbitres' && <h3>Les arbitres</h3>}
            {!type && (
              <h3>
                {annuaire.commission === 'Comité directeur' ? annuaire.commission : annuaire.organigrammeType + ' - ' + annuaire.commission}
              </h3>
            )}
            <div className="input input--search" data-overlay="false">
              <input type="search" id="ioudf892" placeholder={placeholder} onChange={this.handleChange} />
              <label htmlFor="ioudf892">{placeholder}</label>
            </div>
          </div>
          {this.renderGroup()}
        </>
      );
    }
    return null;
  }
}

export default Annuaire;
